export default {"src":"/_next/static/media/bank_preferred_icon.e11eebc3.svg","height":18,"width":64,"blurWidth":0,"blurHeight":0};